/**
 * 判断是否为有限数
 * @return {Boolean}
 */
import isNumber from './is-number';

export default function(value: any) : value is number {
    return isNumber(value) && isFinite(value)
}


